module.exports = __webpack_public_path__ + "img/email.75928f83.svg";